module.exports = __webpack_public_path__ + "static/media/nypost.com_2016_11_09_the-one-scenario-that-could-still-get-hillary-into-the-white-house__plot.761384c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/nypost.com_2016_11_09_the-one-scenario-that-could-still-get-hillary-into-the-white-house__plot.png
// module id = 404
// module chunks = 0